import React from 'react';
import Button from 'seedly-component-library/button-new';
import { ChevronRight } from 'react-feather';

const PlanInfoCard = props => {
  const { applyNowUrl, onApplyNowClick = () => {}, ctaTitle } = props;
  return (
    <div className="card">
      <div className="flex flex-col w-full h-full justify-between">
        {props.children}
        <div className="flex flex-row-reverse w-full justify-between">
          {applyNowUrl && (
            <a href={applyNowUrl} target="_blank" rel="noopener noreferrer">
              <Button onClick={onApplyNowClick} data-testid="link-apply-now">
                {ctaTitle ? `${ctaTitle}` : 'Apply Now'}
                {ctaTitle && <ChevronRight size={18} className="ml-1" />}
              </Button>
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default PlanInfoCard;
